<template>
  <v-container fluid style="background-color: var(--v-background-base);" class="pa-10" v-if="!loadingToken">
    <v-form ref="quoteForm">
      <JuridicalPersonData id="juridicalPersonData" ref="juridicalPersonData" @selectProject="selectProject"></JuridicalPersonData>
      <ProjectConfigurations ref="projectConfigurations" :city="juridicalPersonObj.city" @selectProject="selectProject" @emptyProjects="emptyProjects"></ProjectConfigurations>
      
      <v-row class="py-5">
        <v-col cols="12" md="5"  style="color: var(--v-darkblue-base); font-weight: bold; font-size: 14px;">
          <JuridicalPersonLifeCount ref="juridicalPersonLifeCount"
            v-if="selectedJuridicalPerson && selectedJuridicalPerson.trim() === 'PJ'" 
            @confirmDialogAndContinue="confirmDialogAndContinue"
            @cancelDialogAndContinue="cancelDialogAndContinue"
            :showDialogLifes="showDialog">
          </JuridicalPersonLifeCount>
          
          <JuridicalPersonPlanLifeCount ref="juridicalPersonPlanLifeCount"
             v-else-if="selectedJuridicalPerson && selectedJuridicalPerson.trim() === 'PJ_PLAN'">
          </JuridicalPersonPlanLifeCount>
        </v-col>
        
        <v-col cols="12" md="7" class="mt-md-0">
          <ContractSpecificationFilters ref="contractSpecificationFilters"></ContractSpecificationFilters>
        </v-col>
        
        <v-col cols="12">
          <v-card>
            <v-card-actions class="px-0 py-3">
              <v-spacer></v-spacer>
              <v-btn
                :disabled="loading || iReadOnly"
                class="btn-quote ml-0 mr-2"
                large
                width="130"
                @click="() => showDialogClearFields = !showDialogClearFields">
                <v-icon left>fas fa-redo</v-icon>
                Limpar
              </v-btn>
              <v-btn
                :disabled="iReadOnly"
                :loading="loading"
                class="btn-quote ml-0 mr-2"
                large
                width="130"
                @click="onClickNext()">
                <v-icon left>fas fa-check</v-icon>
                Prosseguir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <ConfirmDialog 
        :textDialog="'Você deseja realmente limpar os campos do formulário?'"
        :showDialog="showDialogClearFields"
        @onClickCancelDialog="onClickCancelDialog" 
        @onClickConfirmDialog="onClickConfirmDialog">
      </ConfirmDialog>
    </v-form>
    
    <v-form ref="plansForm">
      <PlansSlider 
        id="plansSlider" v-if="showPlansSlider" 
        @hidePlansSlider="hidePlansSlider" 
        :selectedJuridicalPerson="selectedJuridicalPerson"
        :benefitsLoaded="benefitsObj">
      </PlansSlider>
    </v-form>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ProjectConfigurations from "@/components/quote-form/projectConfigurations.vue";
import JuridicalPersonData from "@/components/quote-form/juridicalPersonData.vue";
import JuridicalPersonLifeCount from "@/components/quote-form/juridicalPersonLifeCount.vue";
import JuridicalPersonPlanLifeCount from "@/components/quote-form/juridicalPersonPlanLifeCount.vue";
import ContractSpecificationFilters from "@/components/quote-form/contractSpecificationFilters.vue";
import PlansSlider from "@/components/quote-form/plansSlider.vue";
import ConfirmDialog from "@/components/quote-form/confirmationDialog.vue";
import QuoteService from "@/services/odoo/QuoteService";
import XippAuthService from "@/services/auth/XippAuthService";

export default {
  name: 'quoteForm',
  components: {
    JuridicalPersonData,
    JuridicalPersonLifeCount,
    JuridicalPersonPlanLifeCount,
    ContractSpecificationFilters,
    PlansSlider,
    ConfirmDialog,
    ProjectConfigurations,
  },
  data: () => ({
    iReadOnly: false,
    isEmptyProjects: false,
    quoteSessionkey: 'quoteDataObj',
    showPlansSlider: false,
    showDialogClearFields: false,
    selectedJuridicalPerson: null,
    showDialog: false,
    isUpdateAgeInterval: false,
    loading: false,
    loadingToken: false
  }),
  methods: {
    ...mapMutations(['showmsg', 'setDialogLoading', 'toogleDialogLoading']),
    ...mapActions(['setBenefitsObj', 'setProjectId', 'setParentQuoteId', 'setQuoteId']),
    scrollToElementById(id) {
      if(id) {
        setTimeout(() => {
          const element = document.getElementById(id);
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 250);
      }
    },
    cancelDialogAndContinue(status) {
      this.showDialog = status;
    },
    confirmDialogAndContinue(status) {
      this.showDialog = status;
      this.loadAllPlansByFilters();
    },
    validateJuridicalPersonType() {
      this.iReadOnly = this.$route.query.detail && (this.$route.query.detail === true || this.$route.query.detail === 'true');
      this.selectedJuridicalPerson = this.$route.query.type;
      if(!this.selectedJuridicalPerson || (this.selectedJuridicalPerson.trim() !== 'PJ' && this.selectedJuridicalPerson.trim() !== 'PJ_PLAN')) {
        this.$router.push({name: 'home', params: {incorrectType: 'true'}})
      }
    },
    onClickCancelDialog() {
      this.showDialogClearFields = !this.showDialogClearFields;
    },
    onClickConfirmDialog() {
      this.onClickClear();
      this.showDialogClearFields = !this.showDialogClearFields;
    },
    onClickClear() {
      this.$refs.juridicalPersonData.clearFields();
      this.$refs.contractSpecificationFilters.clearFields();
      
      if(this.selectedJuridicalPerson === 'PJ') {
        this.$refs.juridicalPersonLifeCount.clearFieds();
      } else if (this.selectedJuridicalPerson === 'PJ_PLAN') {
        this.$refs.juridicalPersonPlanLifeCount.clearFieds();
      }
      
      if(this.$refs.projectConfigurations) {
        this.$refs.projectConfigurations.clearFields();
      }
      
      this.$refs.quoteForm.resetValidation();
      this.showPlansSlider = false;
      
      if (sessionStorage.getItem(this.quoteSessionkey)) {
        sessionStorage.removeItem(this.quoteSessionkey);
      }
    },
    hidePlansSlider() {
      this.showPlansSlider = false;
      this.$refs.contractSpecificationFilters.clearFields();
      this.setParentQuoteId(null);
      this.setQuoteId(null);
    },
    onClickNext() {
      if(!this.$refs.quoteForm.validate()) {
        this.scrollToElementById('juridicalPersonData');
        return;
      }
      
      if((!this.projectObj || !this.projectObj.id) && !this.isEmptyProjects) {
        this.showmsg({text: 'Por favor, selecione um projeto.', type: 'warning'})
        return;
      } else if (this.isEmptyProjects) {
        this.showMsgEmptyProjects();
        return;
      }
      
      if(!this.ageIntervalsObj || !this.ageIntervalsObj.length || (this.ageIntervalsObj && this.ageIntervalsObj.length 
        && this.ageIntervalsObj.every(item => !item.total || item.total === 0))) {
        this.showmsg({text: 'Por favor, informe o número de vidas.', type: 'warning'})
        return;
      }

      if(!this.planFiltersObj || !this.planFiltersObj.allEmployees.length|| !this.planFiltersObj.hasCopay.length
        || !this.planFiltersObj.accommodations.length || !this.planFiltersObj.geographicScopes.length
        || !this.planFiltersObj.planClassifications.length) {
        this.showmsg({text: 'Por favor, infome as características do contrato.<br/>' +
            'Opcionais: hospitais e laboratórios.', type: 'warning'})
        return;
      }
      
      this.showPlansSlider = false;
      
      if(this.ageIntervalsObj && this.ageIntervalsObj[this.ageIntervalsObj.length - 1] 
        && this.ageIntervalsObj[this.ageIntervalsObj.length - 1].total && this.selectedJuridicalPerson
        && this.selectedJuridicalPerson.trim() !== 'PJ_PLAN') {
        this.showDialog = true;
      } else {
        this.loadAllPlansByFilters();
      }
    },
    async loadAllPlansByFilters() {
      this.loading = true;
      this.setDialogLoading(this.loading);

      if (sessionStorage.getItem(this.quoteSessionkey)) {
        sessionStorage.removeItem(this.quoteSessionkey);
      }
      
      const params = new URLSearchParams();
      if(this.juridicalPersonObj && this.juridicalPersonObj.city) {
        params.append('cityId', this.juridicalPersonObj.city.id);
      }

      if(this.planFiltersObj && this.planFiltersObj.allEmployees && this.planFiltersObj.allEmployees.length) {
        params.append('allEmployees', this.planFiltersObj.allEmployees[0]);
      }

      if(this.planFiltersObj && this.planFiltersObj.hasCopay && this.planFiltersObj.hasCopay.length) {
        params.append('withCopay', this.planFiltersObj.hasCopay[0]);
      }

      if(this.planFiltersObj && this.planFiltersObj.accommodations && this.planFiltersObj.accommodations.length) {
        const accommodation = this.planFiltersObj.accommodations.join(',');
        params.append('accommodation', accommodation);
      }

      if(this.planFiltersObj && this.planFiltersObj.planClassifications && this.planFiltersObj.planClassifications.length) {
        const classification = this.planFiltersObj.planClassifications.join(',');
        params.append('classification', classification);
      }

      if(this.planFiltersObj && this.planFiltersObj.geographicScopes && this.planFiltersObj.geographicScopes.length) {
        const geographicScope = this.planFiltersObj.geographicScopes.join(',');
        params.append('geographicScope', geographicScope);
      }

      if(this.planFiltersObj && this.planFiltersObj.hospitalsObj && this.planFiltersObj.hospitalsObj.length) {
        const hospitalIds = this.planFiltersObj.hospitalsObj.join(',');
        params.append('hospitalIds', hospitalIds);
      }

      if(this.planFiltersObj && this.planFiltersObj.laboratoriesObj && this.planFiltersObj.laboratoriesObj.length) {
        const laboratoryIds = this.planFiltersObj.laboratoriesObj.join(',');
        params.append('laboratoryIds', laboratoryIds);
      }

      if(this.ageIntervalsTotalObj && this.ageIntervalsTotalObj.sumTotal) {
        params.append('totalLives', this.ageIntervalsTotalObj.sumTotal);
      }

      if(this.projectObj && this.projectObj.id) {
        params.append('studyConfigurationId', this.projectObj.id);
      }
      
      await this._quoteService.findAllPlansByFilter(params).
        then((response) => {
          if(response && response.data && response.data.benefits && response.data.benefits.length) {
            this.setBenefitsObj(JSON.parse(JSON.stringify(response.data.benefits)));
            setTimeout(() => {
              this.showPlansSlider = true;
              this.scrollToElementById('plansSlider');
            }, 100);
          } else {
            this.showmsg({text: 'Nenhum benefício foi encontrado com base nas informações preenchidas.', type: 'warning'})
          }
        })
        .catch((error) => {
          if(error && error.response && error.response.status === 400) {
            this.showmsg({text: error.response.data.message, type: 'error'})
          } else {
            this.showmsg({text: 'Ocorreu um erro ao tentar listar os benefícios disponíveis.', type: 'error'})
          }
        });

      this.loading = false;
      this.setDialogLoading(this.loading);
    },
    async reloadDataFromSessionStorage(){
      if (sessionStorage.getItem(this.quoteSessionkey)) {
        this.showPlansSlider = true;
        const quoteData = JSON.parse(atob(sessionStorage.getItem(this.quoteSessionkey)));
        this.setParentQuoteId(quoteData.parentQuoteId);
      } else {
        await this.getQuoteDataFromService();
        this.showPlansSlider = true;
        if (sessionStorage.getItem(this.quoteSessionkey)) {
          const quoteData = JSON.parse(atob(sessionStorage.getItem(this.quoteSessionkey)));
          this.setParentQuoteId(quoteData.parentQuoteId);
          window.location.reload();
        }
      }
    },
    async getQuoteDataFromService(){
      this.setDialogLoading(true);

      sessionStorage.removeItem(this.quoteSessionkey);
      if(this.$route.query.id) {
        let quoteData = null;

        if(!this.$route.query.cnpj) {
          await this._quoteService.detail(this.$route.query.id)
            .then((response) => {
              if (response && response.data) {
                quoteData = response.data;
              }
            })
            .catch((error) => {
              this.setDialogLoading(false);
              if (error && error.response && error.response.status === 400) {
                this.showmsg({text: error.response.data.message, type: 'error'})
              } else {
                this.showmsg({text: 'Ocorreu um erro ao tentar detalhar a cotação.', type: 'error'})
              }
            });
        }

        if(quoteData) {
          if(quoteData.type == this.$route.query.type){
            const parentQuoteId = quoteData && quoteData.id ? quoteData.id : this.$route.query.id;

            const juridicalPersonObj = {
              cnpj: quoteData && quoteData.lead ? quoteData.lead.cnpj : null,
              legalName: quoteData && quoteData.lead ? quoteData.lead.commercialName : null,
              nameContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.name : null,
              phoneContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.mobilePhone : null,
              emailContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.email : null,
              emailWithCopy: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.emailCC : null,
              city: quoteData && quoteData.lead && quoteData.lead.city ? {
                id: quoteData.lead.city.id,
                name: quoteData.lead.city.name,
                state_id: {
                  id: quoteData.lead.city.state ? quoteData.lead.city.state.id : null,
                  name: quoteData.lead.city.state ? quoteData.lead.city.state.name : null,
                  code: quoteData && quoteData.lead && quoteData.lead.city && quoteData.lead.city.state ? quoteData.lead.city.state.code : null,
                }
              } : null,
            }

            const planFiltersObj = {
              accommodations: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.accommodation && quoteData.contractFeatures.accommodation.length
                ? quoteData.contractFeatures.accommodation.map(item => item.code) : [],
              allEmployees: quoteData && quoteData.contractFeatures ? [quoteData.contractFeatures.allEmployees] : [],
              geographicScopes: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.geographicScope && quoteData.contractFeatures.geographicScope.length
                ? quoteData.contractFeatures.geographicScope.map(item => item.name) : [],
              hasCopay: quoteData && quoteData.contractFeatures ? [quoteData.contractFeatures.withCopay] : [],
              planClassifications: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.classification && quoteData.contractFeatures.classification.length
                ? quoteData.contractFeatures.classification.map(item => item.id ? item.id.toString() : null) : [],
              hospitalsObj: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.hospitalProviders && quoteData.contractFeatures.hospitalProviders.length
                ? quoteData.contractFeatures.hospitalProviders.map(item => item.id) : [],
              laboratoriesObj: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.laboratoryProviders && quoteData.contractFeatures.laboratoryProviders.length
                ? quoteData.contractFeatures.laboratoryProviders.map(item => item.id) : [],
            }


            let benefitsObj = quoteData && quoteData.benefit ? quoteData.benefit : [];
            if (benefitsObj && benefitsObj.length) {
              benefitsObj.forEach(benefit => {
                benefit.carriers.forEach(carrier => {
                  const selectedPlans = carrier.selectedPlans;
                  carrier.planClassifications.forEach(planClassification => {
                    planClassification.plans.forEach(plan => {
                      if (selectedPlans && selectedPlans.length && selectedPlans.some(selectedPlan => parseInt(selectedPlan.id) === parseInt(plan.id))) {
                        plan.selected = true;
                      }
                    });
                  });
                });
              });
            }

            let ageIntervalsObj = [];
            let enumeratedAgesObj = [];
            let plansGroupByBenefitCarrierObj = [];
            if (quoteData && quoteData.type && quoteData.type === 'PJ') {
              ageIntervalsObj = quoteData && quoteData.ageRange ? quoteData.ageRange : [];
              enumeratedAgesObj = ageIntervalsObj[ageIntervalsObj.length - 1].beneficiariesFiftyNinePlus ?
                ageIntervalsObj[ageIntervalsObj.length - 1].beneficiariesFiftyNinePlus : [];
            } else if (quoteData && quoteData.type && quoteData.type === 'PJ_PLAN') {
              ageIntervalsObj = quoteData && quoteData.ageRange ? quoteData.ageRange : [];
              plansGroupByBenefitCarrierObj = this.groupPlansByBenefitCarrier(benefitsObj);
            }

            if (ageIntervalsObj && ageIntervalsObj.length) {
              ageIntervalsObj.forEach(item => {
                delete item.beneficiariesFiftyNinePlus;
              })
            }

            const projectObj = {id: null};
            if (quoteData && quoteData.studyConfigurationId) {
              projectObj.id = parseInt(quoteData.studyConfigurationId);
            }

            const quoteDataSession = {
              parentQuoteId,
              juridicalPersonObj,
              planFiltersObj,
              ageIntervalsObj,
              enumeratedAgesObj,
              benefitsObj,
              plansGroupByBenefitCarrierObj,
              projectObj
            }

            sessionStorage.setItem(this.quoteSessionkey, btoa(JSON.stringify(quoteDataSession)));
          } else {
            const parentQuoteId = quoteData && quoteData.id ? quoteData.id : this.$route.query.id;

            const juridicalPersonObj = {
              cnpj: quoteData && quoteData.lead ? quoteData.lead.cnpj : null,
              legalName: quoteData && quoteData.lead ? quoteData.lead.commercialName : null,
              nameContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.name : null,
              phoneContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.mobilePhone : null,
              emailContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.email : null,
              emailWithCopy: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.emailCC : null,
              city: quoteData && quoteData.lead && quoteData.lead.city ? {
                id: quoteData.lead.city.id,
                name: quoteData.lead.city.name,
                state_id: {
                  id: quoteData.lead.city.state ? quoteData.lead.city.state.id : null,
                  name: quoteData.lead.city.state ? quoteData.lead.city.state.name : null,
                  code: quoteData && quoteData.lead && quoteData.lead.city && quoteData.lead.city.state ? quoteData.lead.city.state.code : null,
                }
              } : null,
            }

            const quoteDataSession = {
              parentQuoteId,
              juridicalPersonObj
            }

            sessionStorage.setItem(this.quoteSessionkey, btoa(JSON.stringify(quoteDataSession)));
          }
        }
      }
      this.setDialogLoading(false);
    },
    selectProject(projectId) {
      this.setProjectId(projectId);
    },
    emptyProjects(status) {
      this.isEmptyProjects = status;
      if(status){
        this.showMsgEmptyProjects();
      }
    },
    groupPlansByBenefitCarrier(benefits) {
      let plansGroupByBenefitCarrier = [];
      const sumTotals = {
        ageIntervalsSum: [
          { description: '0 a 18', sum: null },
          { description: '19 a 23', sum: null },
          { description: '24 a 28', sum: null },
          { description: '29 a 33', sum: null },
          { description: '34 a 38', sum: null },
          { description: '39 a 43', sum: null },
          { description: '44 a 48', sum: null },
          { description: '49 a 53', sum: null },
          { description: '54 a 58', sum: null },
          { description: '59 ou +', sum: null },
        ],
        total: null,
      };

      const initialAgeIntervals = [
        { description: '0 a 18', holderCount: null, dependentCount: null, total: null },
        { description: '19 a 23', holderCount: null, dependentCount: null, total: null },
        { description: '24 a 28', holderCount: null, dependentCount: null, total: null },
        { description: '29 a 33', holderCount: null, dependentCount: null, total: null },
        { description: '34 a 38', holderCount: null, dependentCount: null, total: null },
        { description: '39 a 43', holderCount: null, dependentCount: null, total: null },
        { description: '44 a 48', holderCount: null, dependentCount: null, total: null },
        { description: '49 a 53', holderCount: null, dependentCount: null, total: null },
        { description: '54 a 58', holderCount: null, dependentCount: null, total: null },
        { description: '59 ou +', holderCount: null, dependentCount: null, total: null },
      ];

      if(benefits && benefits.length) {
        benefits.forEach(benefitItem => {
          benefitItem.carriers.forEach(carrierItem => {
            carrierItem.planClassifications.forEach(planClassification => {
              planClassification.plans.forEach(planItem => {
                const planSelectedFound = carrierItem.selectedPlans.find(selectedPlan => parseInt(selectedPlan.id) === parseInt(planItem.id));

                if(planSelectedFound) {
                  const benefitCarrier = {
                    benefitId: benefitItem.id,
                    benefitName: benefitItem.name,
                    benefitCode: benefitItem.code,
                    carrierId: carrierItem.id,
                    carrierName: carrierItem.name,
                    carrierDirectoryKit: carrierItem.directoryKit,
                    carrierComercialName: carrierItem.comercialName,
                    carrierImage: carrierItem.image,
                    carrierIsReference: carrierItem.isReference,
                    plans: [],
                    sumTotals: JSON.parse(JSON.stringify(sumTotals)),
                  }

                  const plan = {
                    id: planItem.id,
                    name: planItem.name,
                    ageIntervals: planSelectedFound ? planSelectedFound.ageRange : initialAgeIntervals,
                    ageIntervalsTotal: {
                      sumHolderCount: null,
                      sumDependentCount: null,
                      sumTotal: null,
                    },
                  };

                  const benefitCarrierFound = plansGroupByBenefitCarrier.find(benefitCarrier =>
                    benefitCarrier.benefitId === benefitItem.id && benefitCarrier.carrierId === carrierItem.id);
                  if(benefitCarrierFound) {
                    const indexOfBenefitCarrier = plansGroupByBenefitCarrier.indexOf(benefitCarrierFound);
                    const planFound = benefitCarrierFound.plans.find(plan => plan.id === planItem.id);

                    if(planFound) {
                      const indexOfPlan = benefitCarrierFound.plans.indexOf(planFound);
                      plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.splice(indexOfPlan, 1);

                      if(!plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.length) {
                        plansGroupByBenefitCarrier.splice(indexOfBenefitCarrier, 1);
                      }

                    } else {
                      plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.push(plan);
                    }
                  } else {
                    benefitCarrier.plans.push(plan);
                    plansGroupByBenefitCarrier.push(benefitCarrier);
                  }
                }
              });
            });
          });
        });
      }
      return plansGroupByBenefitCarrier;
    },
    showMsgEmptyProjects() {
      this.showmsg({text: 'No momento não foi encontrado produto disponível para sua região.', type: 'warning'})
    },
    async loadJWTToken() {
      if(this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";
        
        localStorage.setItem(sessionKey, this.$route.query.token);
        this.loadingToken = true;
        this.setDialogLoading(this.loadingToken);
        
        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          })
          .finally(() => {
            this.loadingToken = false;
            this.setDialogLoading(this.loadingToken);
          });
      }
    }
  },
  computed: {
    ...mapGetters(['ageIntervalsObj', 'enumeratedAgesObj', 'juridicalPersonObj', 'planFiltersObj', 'ageIntervalsTotalObj', 'benefitsObj', 'projectObj']),
  },
  beforeCreate() {
    this._quoteService = new QuoteService();
    this._xippAuthService = new XippAuthService();
  },
  async created() {
    await this.loadJWTToken();    
    this.validateJuridicalPersonType();
    this.reloadDataFromSessionStorage();
  }
};
</script>

<style scoped>

.component-col {
  height: 40px !important;
}

.component-col-dual {
  height: 65px !important;
}

.subtitle {
  color: var(--v-foreground-base);
  font-weight: bold;
}

.switch {
  height: 40px;
}

@media only screen and (min-width: 960px) and (max-width: 1000px) {
  .subtitle {
    margin-bottom: 25px;
  }
}
</style>
